var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.916 12.15a.2.2 0 0 1 0-.292l7.715-7.728a1.243 1.243 0 0 0 0-1.768 1.257 1.257 0 0 0-1.766 0l-7.715 7.72a.21.21 0 0 1-.3 0l-7.715-7.72a1.258 1.258 0 0 0-2.039.405 1.24 1.24 0 0 0 .273 1.363l7.715 7.728a.2.2 0 0 1 0 .292l-7.715 7.72a1.243 1.243 0 0 0 0 1.768 1.26 1.26 0 0 0 1.766 0l7.715-7.72a.21.21 0 0 1 .3 0l7.715 7.72a1.258 1.258 0 0 0 2.04-.405 1.24 1.24 0 0 0-.274-1.363z"
  })));
};
export default SvgClose;